import React, { useEffect, useState } from "react";

const MESSAGES = [
  "Inicializacija agenta...",
  "Nalaganje tajnih podatkov...",
  "Ustvarjanje identitete...",
  "Šifriranje obraznih značilnosti...",
  "Misija v teku...",
];

export default function ProcessingScreen() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 2200);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      className="relative min-h-screen w-full flex flex-col items-center justify-center px-6"
      data-testid="processing-screen"
    >
      {/* Gun barrel rotating ring */}
      <div className="relative w-56 h-56 sm:w-72 sm:h-72 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full border border-[#C9A961]/15" />
        <div className="absolute inset-4 rounded-full border border-[#C9A961]/25" />
        <div className="absolute inset-8 rounded-full border border-[#C9A961]/40 barrel-spin">
          <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-[#C9A961]" />
          <div className="absolute top-1/2 -right-1.5 -translate-y-1/2 w-2 h-2 rounded-full bg-[#C9A961]/60" />
        </div>
        <div className="absolute inset-14 rounded-full border border-[#C9A961]/70" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-display text-[#C9A961] text-5xl sm:text-6xl tracking-bond">
            007
          </span>
        </div>
      </div>

      <div className="mt-12 h-10 overflow-hidden">
        <p
          key={idx}
          className="text-[#A1A1AA] uppercase tracking-[0.35em] text-xs sm:text-sm letter-reveal"
          data-testid="processing-message"
        >
          {MESSAGES[idx]}
        </p>
      </div>

      <p className="mt-6 text-[#A1A1AA]/60 text-xs tracking-[0.3em] uppercase">
        Postopek traja nekaj sekund
      </p>
    </div>
  );
}
